import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { CompanyShareholder, CompanyShareholdersResponse, ExportShareholdersResponse, GetMajorShareholdersResponse, ShareholderType } from '../models/shareholder';

export const onGetMajorShareholders = async (share_type: ShareholderType) => {
	try {
		const response = await axios.get<JsonResponse<GetMajorShareholdersResponse>>('dashboard/major-shareholders', {
			params: { type: share_type },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetAllShareholders = async (type: ShareholderType, page = 1) => {
	try {
		const response = await axios.get<JsonResponse<CompanyShareholdersResponse>>(`dashboard/all-shareholders`, {
			params: { type, page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onExportShareholders = async (type: ShareholderType) => {
	try {
		const response = await axios.get<JsonResponse<ExportShareholdersResponse | null>>(`dashboard/all-shareholders/export`, {
			params: { type },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
